import lazyScreen from '../utils/lazyScreen';
const FoodDeliveryMonitor = lazyScreen(() => import('../pages/food/FoodDeliveryMonitor/index.js'), 'pages/food/FoodDeliveryMonitor/index.js');

export default [
    { path: '/food/FoodDeliveryMonitor', component: FoodDeliveryMonitor },
    { path: '/food/INTFoodOrders', component: FoodDeliveryMonitor },
    { path: '/food/INTFoodEvents', component: FoodDeliveryMonitor },
    { path: '/food/INTFoodJobQueues', component: FoodDeliveryMonitor }
];
